import { render, staticRenderFns } from "./ModalSearchResult.vue?vue&type=template&id=76601752&"
import script from "./ModalSearchResult.vue?vue&type=script&lang=ts&"
export * from "./ModalSearchResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports